@defer (on immediate) {
  <section resource-hero [slides]="heroSlides"></section>
} @placeholder {
  <section class="vw-100 vh-100"></section>
}
<section
  jump-to
  [jumpToData]="jumpToData"
  [activeSection]="jumpToData[0].buttonFragment"
  [mobileWrap]="true"
  [reorderMobile]="false"
  [wrapIndex]="1"
></section>
<section callouts></section>
<section id="stay-connected" cta-bottom class="useful-tools max-1190 mx-auto" [data]="ctaBottomData"></section>
<section references class="max-1190 mx-auto"></section>
<review-bar [isUpdated]="false" [dateText]="'in August 2026'"></review-bar>